// React Apps
import './apps/product-tiles/index.jsx'
import './apps/rebuy-bundle/index.jsx'

// Sections
import { setupFourUp } from './sections/four-up.js'
import { setupTwoUp } from './sections/two-up.js'
import { setupImageWithText } from './sections/image-with-text.js'
import { setupImageBanner } from './sections/image-banner.js'
import { setupShopTheLook } from './sections/shop-the-look.js'
import { setupCollectionAdditionals } from './sections/collection.js'
import { setupProductAdditionals } from './sections/product.js'
import { setupClinicalPiercingStandard } from './sections/clinical-piercing-standard.js'
import { setupFooter } from './sections/footer.js'

// Components
import { setupPdpRebuyUpsells } from './components/PdpRebuyUpsells.js'
import { setupAlertMessage } from './components/AlertMessage.js'

document.addEventListener('DOMContentLoaded', () => {
  // Sections
  setupFourUp()
  setupTwoUp()
  setupImageWithText()
  setupImageBanner()
  setupShopTheLook()
  setupProductAdditionals()
  setupCollectionAdditionals()
  setupClinicalPiercingStandard()
  setupFooter()

  // Components
  setupPdpRebuyUpsells()
  setupAlertMessage()
})